export const FETCH_MATERIALS_LIST_REQUEST = "FETCH_MATERIALS_LIST_REQUEST";
export const FETCH_MATERIALS_LIST_SUCCESS = "FETCH_MATERIALS_LIST_SUCCESS";
export const FETCH_MATERIALS_LIST_FAILURE = "FETCH_MATERIALS_LIST_FAILURE";
